import {FreeSpinsRetriggerState, GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot';
import {GameLogic} from 'src/server/GameLogic';

export class GameFreeSpinsRetriggerState extends FreeSpinsRetriggerState {
    public onEnterState(): void {
        const logic = this.module.logic as GameLogic;
        const type = GenericPopupType.FREESPIN_RETRIGGER;
        const fgBonus = logic.getFreeGames();

        this.emit(GenericPopupEvents.SHOW_POPUP, type, this.module.getValueByType(type), fgBonus.getFreeGameType());
    }
}
